import { exeRequest } from '../utils/APIUtils'

const buildQuery = (params = {}) => {
  const cleaned = Object.entries(params).reduce((acc, [k, v]) => {
    if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) return acc;
    acc[k] = Array.isArray(v) ? v.join(',') : v;
    return acc;
  }, {});
  const qs = new URLSearchParams(cleaned).toString();
  return qs ? `?${qs}` : '';
};


// eslint-disable-next-line import/no-anonymous-default-export
export default {

    getList: async (params) => exeRequest(`/admin/souscripteurs${buildQuery(params)}`, "GET"),

    getById: async (id) => exeRequest(`/admin/souscripteurs/${id}`, "GET"),

}